import { render, staticRenderFns } from "./automctoprtopur.vue?vue&type=template&id=4dd011b2&scoped=true&"
import script from "./automctoprtopur.vue?vue&type=script&lang=js&"
export * from "./automctoprtopur.vue?vue&type=script&lang=js&"
import style0 from "./automctoprtopur.vue?vue&type=style&index=0&id=4dd011b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd011b2",
  null
  
)

export default component.exports